import { TPartnerConfigurationDetails } from 'partner_configuration';
import { createContext } from 'react';

export const ConfigContext = createContext<TPartnerConfigurationDetails>({});
